import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Customers from './components/Customers';
import Inquiries from './components/Inquiries';
import Orders from './components/Orders';
import Deliveries from './components/Deliveries';
import Invoices from './components/Invoices';
import Samples from './components/Samples';
import Users from './components/Users';
import Followups from './components/Followups';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="customers" element={<Customers />} />
          <Route path="inquiries" element={<Inquiries />} />
          <Route path="orders" element={<Orders />} />
          <Route path="deliveries" element={<Deliveries />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="samples" element={<Samples />} />
          <Route path="users" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="followups" element={<Followups />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
